import { css } from 'aphrodite';
import * as React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Input } from '../../../../../../../../web/components-v2/Input';
import { Pill } from '../../../../../../../../web/components-v2/Pill';
import { LightBulbIcon } from '../../../../../../../../web/components/svgs/icons/LightBulbIcon';
import { styleSheet } from '../styles';
import { ErrorMessage } from './ErrorMessage';

interface AttendeeInfoFieldsProps {
	requirePhoneNumber?: boolean;
	isPaid?: boolean;
}

export const AttendeeInfoFields: React.FC<AttendeeInfoFieldsProps> = ({
	requirePhoneNumber = false,
	isPaid = false,
}) => {
	const {
		control,
		formState: { isSubmitted, errors },
	} = useFormContext();

	return (
		<>
			<div className={css(styleSheet.rsvpInfo)}>
				<div className={css(styleSheet.formControl)}>
					<label htmlFor='client-firstName' className={css(styleSheet.label)}>
						First Name <span className={css(styleSheet.required)}>*</span>
					</label>
					<Controller
						name='firstName'
						control={control}
						render={({ field: { ref, ...fieldProps } }) => (
							<Input
								id='client-firstName'
								name='firstName'
								type='text'
								disabled={isPaid}
								{...fieldProps}
								styles={[isPaid && styleSheet.inputDisabled]}
							/>
						)}
					/>
					{isSubmitted && errors.firstName && <ErrorMessage message={errors.firstName.message} />}
				</div>

				<div className={css(styleSheet.formControl)}>
					<label htmlFor='client-lastName' className={css(styleSheet.label)}>
						Last Name <span className={css(styleSheet.required)}>*</span>
					</label>
					<Controller
						name='lastName'
						control={control}
						render={({ field: { ref, ...fieldProps } }) => (
							<Input
								id='client-lastName'
								name='lastName'
								type='text'
								disabled={isPaid}
								{...fieldProps}
								styles={[isPaid && styleSheet.inputDisabled]}
							/>
						)}
					/>
					{isSubmitted && errors.lastName && <ErrorMessage message={errors.lastName.message} />}
				</div>

				<div className={css(styleSheet.formControl)}>
					<label htmlFor='client-email' className={css(styleSheet.label)}>
						Email <span className={css(styleSheet.required)}>*</span>
					</label>
					<Controller
						name='email'
						control={control}
						render={({ field: { ref, ...fieldProps } }) => (
							<Input
								id='client-email'
								type='text'
								disabled={isPaid}
								{...fieldProps}
								styles={[isPaid && styleSheet.inputDisabled]}
							/>
						)}
					/>
					{isSubmitted && errors.email && <ErrorMessage message={errors.email.message} />}
				</div>

				<div className={css(styleSheet.formControl)}>
					<label htmlFor='client-phone' className={css(styleSheet.label)}>
						Phone{' '}
						{!requirePhoneNumber ? (
							<small style={{ fontSize: 11 }}>(Optional)</small>
						) : (
							<span className={css(styleSheet.required)}>*</span>
						)}
					</label>
					<Controller
						name='phone'
						control={control}
						render={({ field: { ref, ...fieldProps } }) => (
							<Input
								id='client-phone'
								type='text'
								disabled={isPaid}
								{...fieldProps}
								styles={[isPaid && styleSheet.inputDisabled]}
								placeholder='(999)999-9999'
							/>
						)}
					/>
					{isSubmitted && errors.phone && <ErrorMessage message={errors.phone.message} />}
				</div>
			</div>
			{isPaid && (
				<div className={css(styleSheet.paidEventWarningContainer)}>
					<Pill
						color='orange'
						variant='label'
						size='small'
						label='Contact information cannot be edited after an event is paid for. Please reach out to the event host if you have any questions.'
						icon={<LightBulbIcon height={16} width={16} fill='currentColor' />}
					/>
				</div>
			)}
		</>
	);
};
